module.exports = __webpack_public_path__ + "static/media/Error-Red.bdd3cac7.svg";